import { GroupAssign, Model,Location,CIDMGroup, MembershipType } from "../../booking-table/CustomCells";
import Actions from "./Actions";
import DATA_LABEL_TABLE from "../../../../utils/constants/dataLabelTable";
import {
  ACTION_CELL_STYLE,
  ACTION_COLUMN_FLEX,
  createField,
  createSelectionField,
} from "../../components/tableMetaHelpers";

const truncateCellStyle = {
  textOverflow: "ellipsis",
  overflow: "hidden",
  fontWeight: 500,
  whiteSpace: "nowrap",
  paddingRight: 15,
};

export const getGroupTableMeta = (selectionConfig = null) => {
  const withSelection = Boolean(selectionConfig);

  return {
    fields: {
      ...(withSelection
        ? createSelectionField({
            selectionConfig,
            testIdPrefix: "assign-model-group-checkbox",
            getItemId: (item) => item?.id,
          })
        : {}),
      equipmentModel: createField("Model", "0 1 16%", Model),
      location: createField("Location", "0 1 14%", Location),
      membership: createField("Membership type", "0 1 12%", MembershipType),
      cidm: createField("CIDM Group", "0 1 12%", CIDMGroup, truncateCellStyle),
      users: createField(
        DATA_LABEL_TABLE.ADMIN_ASSIGN_GROUP_TABLE.users,
        "0 1 18%",
        GroupAssign,
        truncateCellStyle
      ),
      groupName: createField(DATA_LABEL_TABLE.ADMIN_ASSIGN_GROUP_TABLE.booking_group, "0 1 17%"),
      action: createField(null, ACTION_COLUMN_FLEX, Actions, ACTION_CELL_STYLE),
    },
  };
};

export default getGroupTableMeta;
